import { get } from '../../common/fetchWrapper';
import { replaceHtml } from '../../common/helper';

class AbokaufHandler extends HTMLElement {
  connectedCallback() {
    window.addEventListener("abokauf", (event) => this.handleAbokaufEvent(event));
  }

  async handleAbokaufEvent(event) {
    const abokaufDetails = event.detail;
    await this.loadAbokaufSnippet(abokaufDetails.matnr, abokaufDetails.matnrAbo);
    if (this.aboCheckoutSnippet) {
      this.overlay.showModal();
    }
  }

  async loadAbokaufSnippet(matnr, matnrAbo) {
    let url = this.dataset.url + matnr;
    if (matnrAbo) {
      url += "," + matnrAbo;
    }
    const response = await get(url, "text/html", 20000, undefined);
    if (response.redirected) {
      window.location.replace(response.url);
    } else {
      const html = await response.text();
      replaceHtml(this.aboCheckoutSnippetContainer, html);
    }
  }

  get aboCheckoutSnippetContainer() {
    return this.querySelector(".overlay-content-container");
  }

  get aboCheckoutSnippet() {
    return this.querySelector("abo-express-checkout");
  }

  get overlay() {
    return this.querySelector(".abokauf-overlay");
  }
}

if (!customElements.get("abokauf-handler")) {
  customElements.define("abokauf-handler", AbokaufHandler);
}
